import React from "react";
import styled, { css } from "styled-components";
import { THEME_COLORS } from "../../../ThemeConfig";

// Icons
import plusIcon from "../../../assets/image/icons/plus.svg";
import editIcon from "../../../assets/image/icons/edit.svg";
import deleteIcon from "../../../assets/image/icons/delete.svg";
import importIcon from "../../../assets/image/icons/import.svg";
import exportIcon from "../../../assets/image/icons/export.svg";

const variantStyles = {
  create: {
    border: "#366ee3",
    color: "#366ee3",
    icon: plusIcon,
  },
  create_red: {
    border: "#FE6666",
    color: "#FE6666",
    icon: plusIcon,
  },
  edit: {
    border: "#ff9800",
    color: "#ff9800",
    icon: editIcon,
  },
  delete: {
    border: "#FE6666",
    color: "#FE6666",
    icon: deleteIcon,
  },
  import: {
    border: "#009688",
    color: "#009688",
    icon: importIcon,
  },
  export: {
    border: "#673ab7",
    color: "#673ab7",
    icon: exportIcon,
  },
};

const ActionButtonOutline = ({ variant = "create", label, onClick }) => {
  const { border, color, icon } = variantStyles[variant] || variantStyles.create;

  return (
    <Button border={border} color={color} onClick={onClick}>
      {icon && <Icon src={icon} alt={`${variant} icon`} color={color} />}
      {label}
    </Button>
  );
};

export default ActionButtonOutline;

/* Styles */
const Button = styled.button`
  padding: 8px 14px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  font-family: "DM_sans_medium";
  background: transparent;
  transition: all 0.2s ease;

  ${({ border, color }) => css`
    border: 1px solid ${border};
    color: ${color};
  `}

  &:hover {
    background: ${({ color }) => `${color}10`};
    transform: translateY(-1px);
  }
`;

// Icon with dynamic coloring
const Icon = styled.img`
  width: 16px;
  height: 16px;
  ${({ color }) => css`
    filter: brightness(0) saturate(100%) invert(35%) sepia(95%) saturate(5000%)
      hue-rotate(${getHue(color)}deg);
  `}
`;

// Function to get hue rotation based on color
function getHue(hex) {
  if (hex === "#366ee3") return 210; // Blue
  if (hex === "#FE6666") return 0;   // Red
  if (hex === "#ff9800") return 35;  // Orange
  if (hex === "#009688") return 165; // Teal
  if (hex === "#673ab7") return 270; // Purple
  return 0;
}
